module.exports = window["wcPPCP"]["utils"];